// extracted by mini-css-extract-plugin
export var container = "_6r-0";
export var error = "_6r-9";
export var label = "_6r-5";
export var light = "_6r-6";
export var md = "_6r-3";
export var sm = "_6r-2";
export var thin = "_6r-8";
export var thinBold = "_6r-7";
export var vertical = "_6r-4";
export var xs = "_6r-1";